/**
 * 通用的 keep-alive 控制器
 * 用于控制特定路由在特定场景下跳过一次缓存
 */

const SKIP_KEEP_ALIVE_KEY_PREFIX = 'skipKeepAlive_'

/**
 * 设置某个路由跳过一次 keepAlive
 * @param {string} routePath - 路由路径，如 '/hotelResource/hotelList'
 */
export function skipKeepAliveOnce(routePath) {
  if (!routePath) return
  const key = `${SKIP_KEEP_ALIVE_KEY_PREFIX}${routePath}`
  sessionStorage.setItem(key, '1')
}

/**
 * 检查并消费跳过 keepAlive 的标记
 * 如果标记存在则返回 true 并清除标记，否则返回 false
 * @param {string} routePath - 路由路径
 * @returns {boolean} 是否应该跳过 keepAlive
 */
export function consumeSkipKeepAlive(routePath) {
  if (!routePath) return false
  const key = `${SKIP_KEEP_ALIVE_KEY_PREFIX}${routePath}`
  const shouldSkip = sessionStorage.getItem(key) === '1'
  if (shouldSkip) {
    sessionStorage.removeItem(key)
  }
  return shouldSkip
}

/**
 * 检查某个路由是否设置了跳过 keepAlive 标记（不消费）
 * @param {string} routePath - 路由路径
 * @returns {boolean} 是否设置了跳过标记
 */
export function hasSkipKeepAliveMark(routePath) {
  if (!routePath) return false
  const key = `${SKIP_KEEP_ALIVE_KEY_PREFIX}${routePath}`
  return sessionStorage.getItem(key) === '1'
}

/**
 * 清除某个路由的跳过 keepAlive 标记
 * @param {string} routePath - 路由路径
 */
export function clearSkipKeepAliveMark(routePath) {
  if (!routePath) return
  const key = `${SKIP_KEEP_ALIVE_KEY_PREFIX}${routePath}`
  sessionStorage.removeItem(key)
}

/**
 * composable 形式的 keepAlive 控制器
 * @returns {object} { skipKeepAliveOnce, shouldSkipKeepAlive }
 */
export function useKeepAliveControl() {
  return {
    skipKeepAliveOnce,
    consumeSkipKeepAlive,
    hasSkipKeepAliveMark,
    clearSkipKeepAliveMark,
  }
}
